import React from 'react';
import { useIntl } from 'react-intl';
import { StyledIntegrationBadge } from './styles';

/**
 * Third-party systems a resource can be managed by, keyed by the `resource.integration` value the API
 * sends, mapped to the catalogue key for the badge text. Mirrors `tripleseatIntegrationBadge` in
 * bookings-calendar-view's `ResourceItem`, with Exchange added on the same rule.
 */
export const INTEGRATION_BADGE_MESSAGE_IDS: Record<string, string> = {
  tripleseat: 'tripleseat_integration_badge',
  exchange: 'exchange_integration_badge',
};

interface IntegrationBadgeProps {
  integration?: string | null;
}

/**
 * The "Tripleseat" / "Exchange" badge, shown on the resource details page and on both resource cards
 * in the list (the photo tile and the redesigned row). Renders nothing for native resources and for
 * any integration this app has no label for.
 */
export const IntegrationBadge = ({ integration }: IntegrationBadgeProps): JSX.Element | null => {
  const intl = useIntl();
  const messageId = integration ? INTEGRATION_BADGE_MESSAGE_IDS[integration.toLowerCase()] : undefined;

  if (!messageId) {
    return null;
  }

  return (
    <StyledIntegrationBadge data-testid="integration-badge">
      {intl.formatMessage({ id: messageId })}
    </StyledIntegrationBadge>
  );
};
